import { Component, OnInit, ViewChild } from '@angular/core';
import {FormBuilder} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";
import {BsModalService, BsModalRef} from "ngx-bootstrap";

@Component({
  selector: 'app-client-review-pending',
  templateUrl: './client-review-pending.component.html',
  styleUrls: ['./client-review-pending.component.scss']
})
export class ClientReviewPendingComponent implements OnInit {
  reviwes: any;
  modalRef: BsModalRef;
  @ViewChild("errorModal", {static: true}) errorModal;
  @ViewChild("addModal", {static: true}) addModal;
  view: any;
  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,) { }

  ngOnInit() {
    this.getAllClientReviews();
  }



  getAllClientReviews(){
    this.userService.getAllPendingReviews().subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.reviwes = res.data;
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  approve(id){
    this.userService.approve(id).subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.getAllClientReviews();
          this.notifier.notify('success', res.responseDesc);
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  reject(id){
    this.userService.regect(id).subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.getAllClientReviews();
          this.notifier.notify('success', res.responseDesc);
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  viewMore(item) {
    this.view=item;
    this.addModal.show();
  }
}
